import { render, staticRenderFns } from "./ProductName.vue?vue&type=template&id=7362c149&"
import script from "./ProductName.vue?vue&type=script&lang=js&"
export * from "./ProductName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports